import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { environment } from '@env/environment'
import { IWorkingHours } from '@app/support-module/core/types'

@Injectable({ providedIn: 'root' })
export class GetWorkingHoursQuery {
  constructor(private httpClient: HttpClient) {}

  call(): Observable<IWorkingHours> {
    const url = `${environment.api.app}/help_desk/client/working_hours`
    return this.httpClient.get<IWorkingHours>(url)
  }
}
